// Portal-wide date display. Shows the month as a NAME, not a number:
//   "2026-05-15"  →  "15-May-2026"
// Use this everywhere a date is shown to the user so the format stays consistent.
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// Accepts a YYYY-MM-DD string, an ISO timestamp, a Date, or epoch ms.
// YYYY-MM-DD strings are parsed by hand (not via new Date) so a timezone offset
// can never shift the calendar day back/forward.
export function fmtDate(input) {
  if (input == null || input === "") return "—";
  let y, m, d;
  if (typeof input === "string" && /^\d{4}-\d{2}-\d{2}/.test(input)) {
    [y, m, d] = input.slice(0, 10).split("-").map(Number);
  } else {
    const dt = input instanceof Date ? input : new Date(input);
    if (isNaN(dt.getTime())) return typeof input === "string" ? input : "—";
    y = dt.getFullYear(); m = dt.getMonth() + 1; d = dt.getDate();
  }
  if (!m || m < 1 || m > 12) return typeof input === "string" ? input : "—";
  return `${String(d).padStart(2, "0")}-${MONTHS[m - 1]}-${y}`;
}

// "15-May-2026 14:30" — date (name month) + HH:MM. For timestamps.
export function fmtDateTime(input) {
  if (input == null || input === "") return "—";
  const dt = input instanceof Date ? input : new Date(input);
  if (isNaN(dt.getTime())) return fmtDate(input);
  const t = dt.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });
  return `${fmtDate(dt)} ${t}`;
}
